import { Controller } from "@hotwired/stimulus"

import Chatra from '@chatra/chatra';

export default class extends Controller {

  static values = {
    email: String,
  }

  initialize() {
    let config = {
      ID: '6maki43NgRxkeofWD',
      setup: {
        deferredLoading: true,
        customWidgetButton: '.chat-button'
      }
    }
    Chatra('init', config);
  }

  connect() {
    Chatra('setIntegrationData', {
      email: this.emailValue,
    });
  }

}
